import $ from 'jquery';

import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class ImageSlide {
	
	constructor() {
		setTimeout(() => {
			this.slideImages();
		}, 800);
	}

	slideImages() {

		var controller = new ScrollMagic.Controller();

		function addVisibleClass(event) {
			$(event.target.triggerElement()).addClass('gallery-mask--visible')
		}

		$(".gallery-mask").each(function() {

			var $galleryMask = $(this);

			var galleryMaskScene = new ScrollMagic.Scene({
				triggerElement: this,
				offset: -490,
			})
			.on('start', addVisibleClass)
			.addTo(controller);


		});
	}

}

module.exports = ImageSlide;